import {Trans} from '@lingui/macro';
import React, {FC, useState} from 'react';

import {isElectron} from '../../../../../../libs/shared/helpers/src/environment/platformHelpers';
import {useInitialEffect} from '../../../../../../libs/shared/helpers/src/react/hooks/useEffectHelpers';
import {Button} from '../../../../../../libs/shared/ui/src/components/buttons/button';
import {ButtonVariantsEnum} from '../../../../../../libs/shared/ui/src/components/buttons/buttonConstants';
import {VisualSizesEnum} from '../../../../../../libs/shared/ui/src/styles/commonStyles';
import {useToggle} from '../../../../../../srcCommon/helpers/hookHelpers';
import {OkCancelDialog} from '../../../../../components/common/dialogs/okCancelDialog';
import {useAppSelector} from '../../../../../helpers/reduxHelpers';
import {
  isDefaultEmailClient,
  setAsDefaultEmailClient,
} from '../../../../../services/electron/electronBridgeOutbound';
import {getHost} from '../../../../../store/data/dataSelectors';

/*
 * Component.
 */

export const MakeDefaultEmailClientButton: FC = () => {
  const [isDisabled, setIsDisabled] = useState(false);
  const [isConfirmationOpen, toggleIsConfirmationOpen] = useToggle();
  const host = useAppSelector(getHost);

  useInitialEffect(() => {
    if (isElectron()) {
      isDefaultEmailClient().then(setIsDisabled);
    }
  });

  function maybeRenderConfirmation() {
    if (!isConfirmationOpen) {
      return null;
    }

    return (
      <OkCancelDialog
        title={<Trans id="make-default-email-client-title">Use Front as your default email client?</Trans>}
        okButtonLabel={<Trans id="make-default-email-client-ok">Set as default</Trans>}
        onOkClick={() => {
          toggleIsConfirmationOpen();
          if (isElectron()) {
            setAsDefaultEmailClient();
          } else {
            window.navigator.registerProtocolHandler('mailto', `${host}/compose?mailto=%s`);
          }

          setIsDisabled(true);
        }}
        onRequestClose={toggleIsConfirmationOpen}
      >
        <Trans id="make-default-email-client-body">Front will open whenever you click on an email link</Trans>
      </OkCancelDialog>
    );
  }

  return (
    <>
      {maybeRenderConfirmation()}
      <Button
        variant={ButtonVariantsEnum.SECONDARY}
        size={VisualSizesEnum.MEDIUM}
        onClick={toggleIsConfirmationOpen}
        isDisabled={isDisabled}
      >
        <Trans id="make-default-email-client-button">Make default</Trans>
      </Button>
    </>
  );
};
